module.exports = __webpack_public_path__ + "static/media/IconEnglishLanguage.f91dfe34.png";